import { Component, Input, OnInit } from '@angular/core';
import { AiService } from '../../services/ai.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'tangram-ai-summary',
  templateUrl: './ai-summary.component.html',
  styleUrls: ['./ai-summary.component.scss']
})
export class AiSummaryComponent implements OnInit {
  @Input() pathwayId: string = '';
  @Input() videoId: string = '';
  @Input() isDashboard: boolean = false;
  @Input() subscriptionActive: boolean = false;

  summary: string = '';
  isLoading: boolean = false;
  isExpanded: boolean = true;
  generatedAt: Date | null = null;
  activeProvider: 'gemini' | 'openai' = 'gemini';

  constructor(
    private aiService: AiService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {}

  generateSummary(provider: 'gemini' | 'openai' = 'gemini') {
    // return; // TODO: Temporarily disabled for client demo
    if (!this.subscriptionActive) {
      this.toastr.warning('Active subscription required for AI features.');
      return;
    }

    this.isLoading = true;
    this.summary = '';
    this.activeProvider = provider;

    const request = this.isDashboard
      ? this.aiService.getTangramSummary(this.pathwayId, provider)
      : this.aiService.getMediaSummary(this.videoId, provider);

    request.subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res.success && res.data) {
          this.summary = res.data.summary;
          this.generatedAt = new Date();
        }
      },
      (error: any) => {
        this.isLoading = false;
        if (error.error && error.error.requiresSubscription) {
          this.toastr.warning('Active subscription required for AI features.');
        } else {
          this.toastr.error('Failed to generate summary. Please try again.');
        }
      }
    );
  }

  copySummary() {
    // return; // TODO: Temporarily disabled for client demo
    if (this.summary) {
      navigator.clipboard.writeText(this.summary).then(() => {
        this.toastr.success('Summary copied to clipboard.');
      });
    }
  }
}
